import { ArrayUtils } from 'source/app/services/ArrayUtils';
import { ETexture } from 'source/app/services/UI/Background/Texture/ETexture';
import { ITextureInputs } from 'source/app/services/UI/Background/Texture/Interfaces/ITexture';
import { Texture } from 'source/app/services/UI/Background/Texture/Texture';

export const GetPreferredTexture = () => {
	const randomTexture = ArrayUtils.GetRandomElement(preferredTextures);
	return new Texture(randomTexture).AsDesktopImage();
};

const preferredTextures: ITextureInputs[] = [
	{
		image: ETexture.argyle,
		backgroundColor: { h: 56, s: 6, l: 20, a: 1 }
	},
	{
		image: ETexture['black-scales'],
		backgroundColor: { h: 328, s: 8, l: 27, a: 1 }
	},
	{
		image: ETexture['carbon-fibre'],
		backgroundColor: { h: 48, s: 17, l: 25, a: 1 }
	},
	{
		image: ETexture['carbon-fibre-big'],
		backgroundColor: { h: 255, s: 21, l: 29, a: 1 }
	},
	{
		image: ETexture['checkered-pattern'],
		backgroundColor: { h: 194, s: 18, l: 26, a: 1 }
	},
	{ image: ETexture['concrete-wall-2'] },
	{ image: ETexture['dark-wall'] },
	{ image: ETexture['fabric-1-light'] },
	{ image: ETexture['green-dust-and-scratches'] },
	{ image: ETexture['ice-age'] },
	{ image: ETexture['inspiration-geometry'] },
	{ image: ETexture['light-aluminum'] },
	{ image: ETexture['light-wool'] },
	{ image: ETexture['maze-black'] },
	{ image: ETexture['old-husks'] },
	{ image: ETexture['noise-pattern-with-subtle-cross-lines'] },
	{ image: ETexture['rough-cloth-light'] },
	{ image: ETexture['smooth-wall-1'] },
	{ image: ETexture.tex2res4 },
	{ image: ETexture.type },
	{ image: ETexture['white-diamond'] },
	{ image: ETexture.wood },
	{ image: ETexture.xv }
];
